module.exports = __webpack_public_path__ + "static/media/hahnemuhle-ultra-smooth.c0acf9d9.jpg";